<template>
  <div>
    <v-dialog eager v-model="showDialog" max-width="1380px" :fullscreen="$vuetify.breakpoint.smAndDown" :persistent="$vuetify.breakpoint.smAndDown" v-if="colorStyle != null">
     
      <v-card :height="($vuetify.breakpoint.smAndDown) ? '' : '690px'" style="overflow-y: hidden;position:relative;" v-if="showDialog">
        <!--
        <v-toolbar dense :color="ColorToRGBA(colorStyle.secColor)" v-if="$vuetify.breakpoint.smAndDown">
          <span> </span>
          <v-spacer/>
          <v-btn text color="white" @click="showDialog = false" height="100%">
            <span class="mr-2">Close</span>
            <img src="https://activstoredev.blob.core.windows.net/test/WA/close.png" width="14px" />
          </v-btn>
        </v-toolbar>
        -->
        <v-card height="100%" width="100%" style="position:absolute;" flat :color="this.ColorToRGBA(colorStyle.mainColor)"/>
        <v-img v-if="backgroundImage != null" height="100%" width="100%" :src="backgroundImage" style="position:absolute;" />

        <v-btn tile  height="60px" width="60px" :color="ColorToRGBA(colorStyle.secColor)" elevation="4"  dark @click="selectedAsset = null" style="position:absolute;z-index:10;"  v-if="selectedAsset != null && isMultipleAssets && !$vuetify.breakpoint.smAndDown">
            <v-icon large>
              mdi-chevron-left
            </v-icon>
        </v-btn>

        <template v-if="!isMultipleAssets || selectedAsset != null">
          <v-layout fill-height v-if="!$vuetify.breakpoint.smAndDown">
            <v-flex>
              <v-card v-if="tabs[activeTab].type == 'COLLECTORCARD' || tabs[activeTab].type == 'COMPETITION'" style="position:absolute;right:90px;" color="white" height="100%" width="100%"></v-card>
              <landing-view v-if="tabs[activeTab].type == 'LANDING'" :colorStyle="colorStyle" :resources="tabs[activeTab].resources" :asset="asset" v-on:nextTab="activeTab += 1"> </landing-view>
              <three-sixty-resource-view v-else-if="tabs[activeTab].type == '360PRODUCT'" :resources="tabs[activeTab].resources" :asset="asset"/>
              <video-resources-view v-else-if="tabs[activeTab].type == 'VIDEO'" :resources="tabs[activeTab].resources" />
              <image-resources-view v-else-if="tabs[activeTab].type == 'IMAGE'" :isMultiple="isMultipleAssets" :asset="asset"  :resources="tabs[activeTab].resources" :typeData="tabs[activeTab].typeData" :icons="GetIcons"/>
              <asset-overview-view v-else-if="tabs[activeTab].type == 'ASSETOVERVIEW'" :asset="asset" :typeData="tabs[activeTab].typeData" :icons="GetIcons" />
              <article-content-view v-else-if="tabs[activeTab].type == 'CONTENT_ARTICLE'" :content="tabs[activeTab].content" :typeData="tabs[activeTab].typeData"/>
              <content-overview v-else-if="tabs[activeTab].type == 'OVERVIEW_CONTENT'" :asset="asset" :resources="tabs[activeTab].resources" :icons="GetIcons" :content="tabs[activeTab].content" :typeData="tabs[activeTab].typeData"/>
              <collector-card-view v-else-if="tabs[activeTab].type == 'COLLECTORCARD'" :touchpointName="asset.name" :collectorsCardRes="collectorsCard"/>
              <competition-view-glasgow-new v-else-if="tabs[activeTab].type == 'COMPETITION' && touchpoint.typeData.assetDetailid == 'aa0490ef-622b-4a27-a9fe-dff8f94ee8d8'" :touchpointName="asset.name"/>
            </v-flex>
            <v-flex shrink style="width:90px" v-if="!$vuetify.breakpoint.smAndDown">

              <v-card id="tabbacking" width="90px" height="100%" :style="tabStyle" color="transparent" class="pa-0 ma-0" flat />
              <v-btn block="" height="90px" width="90px" :color="ColorToRGBA(colorStyle.secColor)" dark ref="exitbutton" @click="showDialog = false" style="z-index:1;" >
                  <img src="https://activstoredev.blob.core.windows.net/test/WA/close.png" width="14px" />
              </v-btn>
              <v-tabs v-model="activeTab" icons-and-text vertical height="600px" color="transparent"  background-color="transparent">
                <v-tab v-for="(tab,index) in tabs" :key="index" :style="'border-bottom: 4px solid ' + ColorToRGBA(colorStyle.secColor,0.1) + ';height:90px!important;'" >
                  <img v-if="tab.type == 'IMAGE'" src="https://activstoredev.blob.core.windows.net/test/WA/gallery.png" width="28px" :style="(activeTab == index) ? 'filter: brightness(1000%)' : tabColor" />
                  <img v-if="tab.type == 'VIDEO'" src="https://activstoredev.blob.core.windows.net/test/WA/video.png" width="33px" :style="(activeTab == index) ? 'filter: brightness(1000%)' : tabColor" />
                  <img v-if="tab.type == '360PRODUCT'" src="https://activstoredev.blob.core.windows.net/test/WA/360.png" width="33px" :style="(activeTab == index) ? 'filter: brightness(1000%)' : tabColor" />
                  <img v-if="tab.type == 'LANDING'" src="https://activstoredev.blob.core.windows.net/test/WA/Home%20Icon.png" width="28px"  :style="(activeTab == index) ? 'filter: brightness(1000%)' : tabColor" />
                  <img v-if="tab.type == 'ASSETOVERVIEW'" src="https://activstoredev.blob.core.windows.net/test/WA/info.png" width="28px"  :style="(activeTab == index) ? 'filter: brightness(1000%)' : tabColor" />
                  <img v-if="tab.type == 'CONTENT_ARTICLE'" src="https://activstoredev.blob.core.windows.net/test/WA/info.png" width="28px"  :style="(activeTab == index) ? 'filter: brightness(1000%)' : tabColor" />
                  <img v-if="tab.type == 'OVERVIEW_CONTENT'" src="https://activstoredev.blob.core.windows.net/test/WA/info.png" width="28px"  :style="(activeTab == index) ? 'filter: brightness(1000%)' : tabColor" />
                  <img v-if="tab.type == 'COLLECTORCARD'" src="https://xpcwa.blob.core.windows.net/assets/CardIcon.png" width="28px"  :style="(activeTab == index) ? 'filter: brightness(1000%)' : tabColor" />
                  <img v-if="tab.type == 'COMPETITION'" src="https://xpcwa.blob.core.windows.net/assets/CardIcon.png" width="28px"  :style="(activeTab == index) ? 'filter: brightness(1000%)' : tabColor" />
                </v-tab>
              </v-tabs>
            </v-flex>
          </v-layout>
          <v-layout style="overflow-y:auto;" v-else>
            <v-flex>
              <v-card v-if="tabs[activeTab].type == 'COLLECTORCARD' || tabs[activeTab].type == 'COMPETITION'" style="position:absolute;" color="white" height="100%" width="100%"></v-card>
              <landing-view v-if="tabs[activeTab].type == 'LANDING'" :colorStyle="colorStyle" :resources="tabs[activeTab].resources" :asset="asset" v-on:nextTab="activeTab += 1"> </landing-view>
              <three-sixty-resource-view v-else-if="tabs[activeTab].type == '360PRODUCT'" :resources="tabs[activeTab].resources" :asset="asset"/>
              <video-resources-view v-else-if="tabs[activeTab].type == 'VIDEO'" :resources="tabs[activeTab].resources" />
              <image-resources-view v-else-if="tabs[activeTab].type == 'IMAGE'" :asset="asset"  :resources="tabs[activeTab].resources" :typeData="tabs[activeTab].typeData" :icons="GetIcons"/>
              <asset-overview-view v-else-if="tabs[activeTab].type == 'ASSETOVERVIEW'" :asset="asset" :typeData="tabs[activeTab].typeData" :icons="GetIcons" />
              <article-content-view v-else-if="tabs[activeTab].type == 'CONTENT_ARTICLE'" :content="tabs[activeTab].content" :typeData="tabs[activeTab].typeData"/>
              <content-overview v-else-if="tabs[activeTab].type == 'OVERVIEW_CONTENT'" :asset="asset" :resources="tabs[activeTab].resources" :icons="GetIcons" :content="tabs[activeTab].content" :typeData="tabs[activeTab].typeData"/>
              <collector-card-view v-else-if="tabs[activeTab].type == 'COLLECTORCARD'" :touchpointName="asset.name" :collectorsCardRes="collectorsCard"/>
              <competition-view-comic-order-form v-else-if="tabs[activeTab].type == 'COMPETITION' && touchpoint.typeData.assetDetailid == '18cfb267-3cc3-40a6-908a-0504a7000d15'" :touchpointName="asset.name"/>
              <competition-view-glasgow-new v-else-if="tabs[activeTab].type == 'COMPETITION' && touchpoint.typeData.assetDetailid == 'aa0490ef-622b-4a27-a9fe-dff8f94ee8d8'" :touchpointName="asset.name"/>
              <div style="height:68px"/>
            </v-flex>
          </v-layout>
        </template>
        <template v-else>
          <v-layout fill-height v-if="!$vuetify.breakpoint.smAndDown">
            <v-flex style="height:100%" v-if="!isManyMultipleAssets" >
              <template v-if="touchpoint.subType == 'TIMELINE'">
                <v-row justify="center" align="center" style="height:100%;">
                  <v-col cols="12">
                    <v-card-title style="position:relative;color:white;font-family:waHeadline;font-size:32px;white-space:nowrap;" class="mb-4" >{{touchpoint.insightTitle}}</v-card-title>
                    <v-layout fill-height>
                      <v-flex style="position:relative;" justify-center class="text-center" v-for="(asset, index) in assets" :key="index">
                        <v-card v-if="index != assets.length -1" color="white" flat height="3px" width="100%" style="position:absolute;right:-50%;top:50%;bottom:50%;" >
                        </v-card>
                        <v-btn fab style="height:" x-large @click="SelectAsset(asset)">
                          {{asset.name}}
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-col>
                </v-row>
              </template>
              <template v-else>
                <v-layout fill-height v-if="!$vuetify.breakpoint.smAndDown" justify-center align-center>
                  <v-flex v-for="(asset,i) in assets" :key="i" class="pa-4" style="height:80%;width:150px;">
                    <v-card width="" height="100%" hover color="transparent" flat @click="SelectAsset(asset)" :style="(i != 0 && assets.length > 1) ? 'border-left: 2px solid white!important' : 'border-left: 2px solid white'" class="pl-8">
                      <v-layout column fill-height align-center justify-center>
                        <v-flex shrink>
                          <v-img
                          style="width:170px;height:180px"
                          
                          :src="getImageForAssetSelection(asset)"
                          >
                          </v-img>
                        </v-flex>
                        <v-flex shrink style="man-height:180px" class="text-center mt-4">
                          <div style="overflow-wrap: break-word;font-weight:bold;">
                            <span style="color:white;font-size:30px;">{{asset.name}}</span>
                            <br/>
                            <span style="color:black;font-size:25px;line-height:20%;">{{asset.description}}</span>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
              </template>
            </v-flex>
            <v-row class="pa-4" align="center" justify="center" v-else>
              <template v-if="touchpoint.subType == 'TIMELINE'">   
                <v-col cols="12">
                  <v-card-title style="position:relative;color:white;font-family:waHeadline;font-size:32px;white-space:nowrap;" class="mb-4" >{{touchpoint.insightTitle}}</v-card-title>
                  <v-layout fill-height>
                    <v-flex style="position:relative;" justify-center class="text-center" v-for="(asset, index) in assets" :key="index">
                      <v-card v-if="index != assets.length -1" color="white" flat height="3px" width="100%" style="position:absolute;right:-50%;top:50%;bottom:50%;" >
                      </v-card>
                      <v-btn fab style="height:" x-large @click="SelectAsset(asset)">
                        {{asset.name}}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-col>
              </template>
              <template v-else>
                <v-col cols="3" v-for="(asset, index) in assets" :key="index">
                  <v-card width="" height="100%" hover color="transparent" flat @click="SelectAsset(asset)" >
                    <v-img
                      style="width:100%;width:180px;height:180px;margin-left:auto;margin-right:auto;display:block;"
                      
                      :src="getImageForAssetSelection(asset)"
                      >
                    </v-img>
                    <div style="overflow-wrap: break-word;font-weight:bold;" class="text-center">
                      <span style="color:white;font-size:25px;">{{asset.name}}</span>
                      <br/>
                      <span style="color:black;font-size:16px;line-height:20%;">{{asset.description}}</span>
                    </div>
                  </v-card>
                </v-col>
              </template>
            </v-row>
            <v-flex shrink style="width:90px" v-if="!$vuetify.breakpoint.smAndDown">
              <v-card id="tabbacking" width="90px" height="100%" :style="tabStyle" color="transparent" class="pa-0 ma-0" flat />
              <v-btn block="" height="90px" width="90px" :color="ColorToRGBA(colorStyle.secColor)" dark ref="exitbutton" @click="showDialog = false" style="z-index:1;" >
                  <img src="https://activstoredev.blob.core.windows.net/test/WA/close.png" width="14px" />
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout fill-height v-else id="Mobile breakpointloc" style="padding-bottom:40px" column>
            <template v-if="touchpoint.subType == 'TIMELINE'"> 
              <v-col cols="12">
                  <v-card-title style="position:relative;color:white;font-family:waHeadline;font-size:24px;white-space:nowrap;" class="mb-4" >{{touchpoint.insightTitle}}</v-card-title>
                  <v-layout fill-height column>
                    <v-flex style="position:relative;min-height:80px;" justify-center class="text-center" v-for="(asset, index) in assets" :key="index" shrink>
                      <v-card v-if="index != assets.length -1" color="white" flat width="3px" height="100%" style="position:absolute;right:50%;left:49.8%;top:50%;bottom:-50%;" >
                      </v-card>
                      <v-btn fab style="height:"  @click="SelectAsset(asset)">
                        {{asset.name}}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-col>
            </template>
            <template v-else>
              <v-flex v-for="(asset,i) in assets" :key="i" class="pa-4" style="">
                <v-card width="" height="100%" hover color="transparent" flat  v-on:click="SelectAsset(asset)" :style="(i != 0 && assets.length > 1) ? 'border-top: 1px solid white!important' : 'border-top: 1px solid white'" class="pt-8">
                  <v-layout column fill-height align-center justify-center>
                      <v-flex shrink>
                      <v-img
                      style="height:100%;max-height:130px;"
                      contain
                      :src="getImageForAssetSelection(asset)"
                      >
                      </v-img>
                      
                    </v-flex>
                    <v-flex shrink class="text-center">
                      <div style="overflow-wrap: break-word;font-weight:bold;">
                        <span style="color:white;font-size:24px;">{{asset.name}}</span>
                        <br/>
                        <span style="color:black;font-size:15px;line-height:20%;">{{asset.description}}</span>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </template>
          </v-layout>
        </template>
      </v-card>
       

      <v-bottom-navigation fixed :background-color="ColorToRGBA(colorStyle.mainColor)" v-model="bottomTab" v-if="$vuetify.breakpoint.smAndDown" grow >
        <v-btn @click="showDialog = false" v-if="selectedAsset == null" small>
           <img src="https://xpcwa.blob.core.windows.net/assets/close_mobile.png" style="height:20px;width:20px;"/>
        </v-btn>
        <v-btn @click="selectedAsset = null" v-if="selectedAsset != null" width="20px">
           <v-icon large color="black" size="18px">
              mdi-chevron-left
            </v-icon>
        </v-btn>
        <template v-if="selectedAsset != null || !isMultipleAssets">
        <v-btn v-for="(tab,index) in tabs" :key="index" style="min-width:20px;!important">
          <img v-if="tab.type == 'IMAGE'" src="https://activstoredev.blob.core.windows.net/test/WA/gallery.png" width="24px" :style="(bottomTab - 1 == index) ? 'filter: brightness(1000%)' : tabColor" />
          <img v-if="tab.type == 'VIDEO'" src="https://activstoredev.blob.core.windows.net/test/WA/video.png" width="24px" :style="(bottomTab - 1 == index) ? 'filter: brightness(1000%)' : tabColor" />
          <img v-if="tab.type == '360PRODUCT'" src="https://activstoredev.blob.core.windows.net/test/WA/360.png" width="24px" :style="(bottomTab - 1 == index) ? 'filter: brightness(1000%)' : tabColor" />
          <img v-if="tab.type == 'LANDING'" src="https://activstoredev.blob.core.windows.net/test/WA/Home%20Icon.png" width="24px"  :style="(bottomTab - 1 == index) ? 'filter: brightness(1000%)' : tabColor" />
          <img v-if="tab.type == 'ASSETOVERVIEW'" src="https://activstoredev.blob.core.windows.net/test/WA/info.png" width="24px"  :style="(bottomTab - 1 == index) ? 'filter: brightness(1000%)' :  tabColor" />
          <img v-if="tab.type == 'CONTENT_ARTICLE'" src="https://activstoredev.blob.core.windows.net/test/WA/info.png" width="24px"  :style="(bottomTab - 1 == index) ? 'filter: brightness(1000%)' : tabColor" />
          <img v-if="tab.type == 'OVERVIEW_CONTENT'" src="https://activstoredev.blob.core.windows.net/test/WA/info.png" width="24px"  :style="(bottomTab - 1 == index) ? 'filter: brightness(1000%)' : tabColor" />
          <img v-if="tab.type == 'COLLECTORCARD'" src="https://xpcwa.blob.core.windows.net/assets/CardIcon.png" width="28px"  :style="(activeTab == index) ? 'filter: brightness(1000%)' : tabColor" />
          <img v-if="tab.type == 'COMPETITION'" src="https://xpcwa.blob.core.windows.net/assets/CardIcon.png" width="28px"  :style="(activeTab == index) ? 'filter: brightness(1000%)' : tabColor" />
        </v-btn>
        </template>
      </v-bottom-navigation>
      
    </v-dialog>

   
   
  </div>
</template>

<script>

import {mapMutations, mapState} from 'vuex'

import CollectorCardView from '../Insights/Misc/CollectorCardView.vue'
import LandingView from '../Insights/LandingView.vue'
import ThreeSixtyResourceView from '../Insights/ResourceViews/ThreeSixtyResourcesView.vue'
import VideoResourcesView from '../Insights/ResourceViews/VideoResourcesView.vue'
import ImageResourcesView from '../Insights/ResourceViews/ImageResourcesView.vue'
import AssetOverviewView from '../Insights/AssetOverviewView.vue'
import ArticleContentView from '../Insights/ContentView/ArticleContentView.vue'
import ContentOverview from '../Insights/ContentView/ContentOverview.vue'
import CompetitionView from './Misc/CompetitionViewOld.vue'
import CompetitionViewGlasgow from './Misc/CompetitionViewGlasgow.vue'
import CompetitionViewGlasgowhun from './Misc/CompetitionViewGlasgowhun.vue'
import CompetitionViewGlasgowNew from './Misc/CompetitionViewGlasgownew.vue'

import { mapGetters } from 'vuex'
import Template from '../Template.vue'

  export default {
    name: 'InsightPopupPanel',
    components: {
      ThreeSixtyResourceView,
      VideoResourcesView,
      ImageResourcesView,
      AssetOverviewView,
      ArticleContentView,
      ContentOverview,
      LandingView,
      CollectorCardView,
      CompetitionView,
      CompetitionViewGlasgow,
      CompetitionViewGlasgowhun,
      CompetitionViewGlasgowNew
    },
    props: {

      touchpoint : null

    },
    computed: {

      languageSetAsHun()
      {
        return this.customSessionData.some(match => match.key == "glasgowCompetitionLanguage");
      },
      tabColor()
      {
        if(this.colorStyle != null && this.colorStyle.identifier == "asics" || this.colorStyle.identifier == "ot")
        {
          return "filter: brightness(600%)";
        }
        else
          return "filter: brightness(0%)";
      },
      tabStyle()
      {
        return 'position:absolute;background-image: webkit-linear-gradient(' + this.ColorToRGBA(this.colorStyle.highlightColor) + ',' + this.ColorToRGBA(this.colorStyle.highlightColor,0) + ');'
      },
      backgroundImage()
      {
        if(this.colorStyle != null)
        {
          return this.colorStyle.backgroundurl;
        }
      },
      getBackgroundImageForActiveTab()
      {
        if (this.tabs[this.activeTab].typeData.backgroundUrl != null)
          return this.tabs[this.activeTab].typeData.backgroundUrl;
        else
          return null;
      },
      isManyMultipleAssets()
      {
        if(this.touchpoint == null)
          return false;
        if(this.touchpoint.typeData.assetDetailids != null && this.touchpoint.typeData.assetDetailids.length > 5)
        {
          return true;
        }
        else
        {
          return false;
        }
      },
      isMultipleAssets()
      {
        if(this.touchpoint == null)
          return false;
        if(this.touchpoint.typeData.assetDetailids != null && this.touchpoint.typeData.assetDetailids.length > 0)
        {
          return true;
        }
        else
        {
          return false;
        }
      },
      collectorsCard()
      {
        return this.asset.resources.find(res => res.tags.includes("CollectorsCard"));
      },

      ...mapState("sessionState", [
        "forceShowAsset",
        "forceShowTab",
        "customSessionData"
      ]),

      ...mapGetters("sessionState", [
        "GetAssetForid",
        "GetAssetsForids",
        "GetInsightTemplateForid",
        "GetIcons",
        "GetInsightStyleForid"
      ]),

    },

    mounted () {

      this.isMounted = true;

    },
    data: () => ({

      showDialog : false,
      isMounted : false,
      tabs : [],
      asset : null,
      activeTab : 0,
      bottomTab : 0,
      colorStyle : null,
      selectedAsset : null,
      assets : null,
      oneFrameprevent : true
    }),
    methods: {

      ...mapMutations("sessionState", [
         "LowerAudioVolume",
         "RaiseAudioVolume",
         "SetForceShowAsset",
         "SetForceShowTab"
      ]),



      SelectAsset(asset)
      {
        if(!this.oneFrameprevent)
        {
          this.CreateTabsForTouchpoint(asset.assetDetailid);
          this.selectedAsset = asset;
        }
      },
      getImageForAssetSelection(asset)
      {
        //Get default resource

        if(asset.resources == null)
          return "";
          
        let defRes = asset.resources.find(res => res.defaultResource == true);

        if(defRes == null)
          return asset.thmUrl;

        return defRes.url;
      },
      ColorToRGBA(styleColor, alphaMultiplier = 1)
      {
        var returnString = "rgba(" + Math.round(styleColor.r * 255) + "," + Math.round(styleColor.g * 255) + "," + Math.round(styleColor.b * 255)  + ",1)";
        return returnString;// +  alphaMultiplier + ")";
      },
      GetResourceEnumValueforType(enumVal)
      {
        if(enumVal == "IMAGE")
        {
          return 0;
        }
        else if (enumVal == "360PRODUCT")
        {
          return 7;
        }
        else if (enumVal == "VIDEO")
        {
          return 4;
        }
        else{
          return -1;
        }
      },
      GetContentEnumValueforType(enumVal)
      {
        if(enumVal == "CONTENT_ARTICLE" || enumVal == "OVERVIEW_CONTENT")
        {
          return 0;
        }
        else{
          return -1;
        }
      },
      CreateTabsForTouchpoint(assetDetailid)
      {
        this.ClearTabs();

        
        this.asset = this.GetAssetForid(assetDetailid);
        this.colorStyle = this.GetInsightStyleForid(this.touchpoint.typeData.colorStyle);

       
        var insightTemplate = this.GetInsightTemplateForid(this.touchpoint.typeData.templateid);

        if(this.isMultipleAssets)
        {
          this.assets = [];
          this.assets = this.GetAssetsForids(this.touchpoint.typeData.assetDetailids);

          if(insightTemplate == null)
          {
            let indexOfSelected = this.touchpoint.typeData.assetDetailids.indexOf(assetDetailid);

            if(indexOfSelected != -1)
            {
              insightTemplate = this.GetInsightTemplateForid(this.touchpoint.typeData.templateids[indexOfSelected]);
            }

            if(insightTemplate == null)
            {
              insightTemplate = this.GetInsightTemplateForid(this.touchpoint.typeData.templateids[0]);
            }
          }

          if(this.asset == null)
          {
            this.asset = this.GetAssetForid(this.touchpoint.typeData.assetDetailids[0]);
          }
        }


        for (let t = 0; t < insightTemplate.tabs.length; t++) {
          let tabTemplate = insightTemplate.tabs[t];

          if(this.GetResourceEnumValueforType(tabTemplate.type) != -1)
          {
            if(this.asset.resources == null)
            {
              continue;
            }

            let validResources = this.asset.resources.filter(resource => resource.type == this.GetResourceEnumValueforType(tabTemplate.type));
        
            if(validResources.length == 0 && tabTemplate.type == "VIDEO")
              continue;
            this.tabs.push({
              type : tabTemplate.type,
              resources : validResources,
              typeData : tabTemplate.typeData
            })
          }
          else if (this.GetContentEnumValueforType(tabTemplate.type) != -1)
          {
            var typeOfContent = this.GetContentEnumValueforType(tabTemplate.type);
            let validContent = this.asset.contents.filter(content => content.type == this.GetContentEnumValueforType(tabTemplate.type))
            
            if(typeOfContent == 0)
            {
              this.tabs.push({
                type : tabTemplate.type,
                content : validContent,
                typeData : tabTemplate.typeData
              });
            }
            else
            {
              for (let c = 0; c < validContent.length; c++) {
                let element = validContent[c];
                this.tabs.push({
                  type : tabTemplate.type,
                  content : element,
                  typeData : tabTemplate.typeData
                })
              }
            }
          }
          else{
            this.tabs.push({
              type : tabTemplate.type,
              typeData : tabTemplate.typeData
            })
          }
        }

        /*

        if(this.asset.assetDetailid == "aa0490ef-622b-4a27-a9fe-dff8f94ee8d8")
        {
          console.log("Matching asset");

          this.tabs.push({
            type : "COMPETITION"
          })

        }

        */

        if(this.asset.resources != null)
        {
          if(this.asset.resources.some(res => res.tags.includes("CollectorsCard")))
          {
            //Collector Card
            this.tabs.push({
              type : "COLLECTORCARD"
            })
          }
        }
      },
      ClearTabs()
      {
        this.tabs = [];
        this.asset = null;
        this.activeTab = 0;
        //this.bottomTab = 1;
      }

    },
    watch: {

      bottomTab : {
        handler(newVal)
        {
          this.activeTab = newVal - 1;
        }
      },
      touchpoint : {

        immediate : true,
        handler(newTouchpoint)
        {
          if(newTouchpoint == null)
          {
            //this.showDialog = false;
          }
          else
          {
            if(newTouchpoint.typeData.assetDetailid != "" || newTouchpoint.typeData.assetDetailids.length > 0)
            {
              this.selectedAsset = null;
              this.showDialog = true;
              this.CreateTabsForTouchpoint(this.touchpoint.typeData.assetDetailid);

            }
          }
          
        }
      },
      showDialog : {

      handler(isShowingDialog)
      {
        if(isShowingDialog)
        {
          this.selectedAsset = null;
          this.$appInsights.trackEvent({name: "show_insight", properties: { id : this.touchpoint.id}});

          setTimeout(() => this.oneFrameprevent = false,400);
          this.$nextTick(() => {

            this.$nextTick(() => {
            });
            var selected = document.querySelector(".v-tabs-bar__content");
            this.selectedAsset = null;
            if(selected != null)
            {
              selected.style.background = "-moz-linear-gradient(rgba(0,0,0,255), rgba(0,0,0,0));"
            }

            console.log("force show assets");
            
            if(this.forceShowAsset != null)
            {
              var fndMatchingAsset = this.assets.find(ass => ass.assetDetailid == this.forceShowAsset);

              console.log("Force show asset is ", fndMatchingAsset);

              if(fndMatchingAsset != null)
              {
                this.CreateTabsForTouchpoint(fndMatchingAsset.assetDetailid);

                this.selectedAsset = fndMatchingAsset;
              }
              this.SetForceShowAsset(null);
            }

            console.log("Setting force show tab");
            console.log(this.forceShowTab);

            this.assets = this.GetAssetsForids(this.touchpoint.typeData.assetDetailids);

            if(this.forceShowTab != null)
            {
              this.activeTab = this.tabs.findIndex(tab => tab.type == "COMPETITION");
              this.SetForceShowTab(null);
            }
    
          })
          
        }
        else
        {
          this.oneFrameprevent = true;
          this.RaiseAudioVolume();
          this.$emit("onCloseInsight")
        }
      }

    }
      
    },
    
  }
</script>

<style>

@font-face {
  font-family: waRegular;
  src: url(https://activstoredev.blob.core.windows.net/test/WA/New%20DirectoryFonts/WorldAthletics-Regular.woff);
}

@font-face {
  font-family: waBold;
  src: url(hhttps://activstoredev.blob.core.windows.net/test/WA/New%20DirectoryFonts/WorldAthletics-Bold.woff);
}

@font-face {
  font-family: waHeadline;
  src: url(https://activstoredev.blob.core.windows.net/test/WA/New%20DirectoryFonts/WorldAthleticsHeadline.woff);
}

</style>
